import { useContext } from "react";
import { AuthContext } from "./AuthContext";
export var useOktaAuth = function () {
  return useContext(AuthContext);
};